function getBaseUrl() {
    if (process.env.NODE_ENV === "development") {
        return process.env.VUE_APP_BASE_URL;
    } else {
        return process.env.VUE_APP_BASE_URL;
    }
}

export {
    getBaseUrl,
}
